export const APP_NAME = "DataView";
export const imageTypes = ["JPG", "JPEG", "PNG", "BMP", "GIF"];

export const checkMobile = () => {
    return window.outerWidth < 800;
};

export const checkLandscape = () => {
    return window.outerWidth > window.outerHeight;
};

export const isNumeric = (val) => {
    if (val === null || isNaN(val)) return false;
    else return true;
};
